export default function DoubleChevronRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L11.7071 12.2929C12.0976 12.6834 12.0976 13.3166 11.7071 13.7071L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L9.58579 13L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289ZM12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L18.7071 12.2929C19.0976 12.6834 19.0976 13.3166 18.7071 13.7071L13.7071 18.7071C13.3166 19.0976 12.6834 19.0976 12.2929 18.7071C11.9024 18.3166 11.9024 17.6834 12.2929 17.2929L16.5858 13L12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289Z"
        fill="currentColor"
      />
    </svg>
  );
}
